import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMoment from 'vue-moment'
import axios from 'axios'
import './registerServiceWorker'
import './assets/sass/style.scss'
import './filters'

Vue.config.productionTip = false

// Axios config
axios.defaults.baseURL = process.env.VUE_APP_API_URL

// Moment JS config
const moment = require('moment')
require('moment/locale/pt-br')
Vue.use(VueMoment, {
  moment
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
